import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  DialogActions,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import {
  DeclineExternalAccountForm,
  ExternalAccountActionButtonProps,
} from '@/types/externalAccounts';
import { SVButton, SVForm, SVTextInput } from '@/components/core';
import { useDeclineExternalAccount } from '@/hooks/requests/useExternalAccounts';
import { MESSAGES } from '@/constants/messages';
import showToast from '@/utils/toast';

export function ExternalAccountDeclineButton({
  id,
}: ExternalAccountActionButtonProps) {
  const [open, setOpen] = useState(false);
  const { declineExternalAccount, isDeclineExternalAccountPending } =
    useDeclineExternalAccount();
  const formMethods = useForm<DeclineExternalAccountForm>({
    defaultValues: {
      reason: '',
      id,
    },
  });

  async function handleConfirm(data: DeclineExternalAccountForm) {
    try {
      await declineExternalAccount(data);
      showToast({
        type: 'success',
        data: { content: 'The external account has been declined' },
      });
    } catch {
      showToast({ type: 'error', data: { content: MESSAGES.genericError } });
    }
  }

  return (
    <>
      <SVButton onClick={() => setOpen(true)} fullWidth variant="outlined">
        Decline
      </SVButton>
      <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
        <SVForm methods={formMethods} onSubmit={handleConfirm}>
          <DialogContent>
            <Box>
              <Typography variant="h6" component="h2">
                Decline External Account
              </Typography>
              <Typography sx={{ mt: 2 }}>
                Are you sure you want to decline this linked account? Declined
                accounts are permanent and a user must upload a new account form
                if they choose to link this account again.
              </Typography>
              <SVTextInput
                name="reason"
                label="Enter a reason for the decline"
                rules={{ required: true }}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <SVButton onClick={() => setOpen(false)} variant="tertiary">
              No, Don't Decline
            </SVButton>
            <SVButton isLoading={isDeclineExternalAccountPending} type="submit">
              Yes, Decline This External Account
            </SVButton>
          </DialogActions>
        </SVForm>
      </Dialog>
    </>
  );
}
